import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  getIntlDefaultLanguage,
  getIntlLanguagesResources,
  IntlLanguageKey,
  IntlLanguages
} from './IntlLanguages';
import moment from 'moment';

const defaultLang = getIntlDefaultLanguage();

/**
 * Carichiamo i18next e provvediamo a configurare la detection della lingua
 * dal browser, nonché l'allineamento con le risorse e le altre opzioni di
 * traduzione che sono configurate **centralmente** in `IntlLanguages`.
 */
// TODO Al momento carichiamo tutte le lingue staticamente (unico bundle) data la dimensione esigua.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: getIntlLanguagesResources(),
    fallbackLng: defaultLang.key,
    lowerCaseLng: true,
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',
    keySeparator: false, // Flat JSON
    interpolation: {
      escapeValue: false // react fa già l'escape
    },
    detection: {
      caches: ['localStorage'],
      order: ['localStorage'],
      lookupLocalStorage: 'pdrlLng'
    }
  });

/**
 * Quando viene cambiata la lingua, modifichiamo anche il locale di moment.
 * Il locale di ant viene sincronizzato automaticamente in `IntlProvider`
 * tramite lo state update.
 */
i18n.on('languageChanged', (lang: IntlLanguageKey) => {
  const language = IntlLanguages[lang];
  moment.locale(language.moment);
});

moment.locale(defaultLang.language.moment);

export default i18n;
